export const SWIPE_BASE_ROUTES = ['/work', '/blog'] as const;

export const OVERLAY_BASE_ROUTES = [
  '/about',
  '/services',
  '/work',
  '/blog',
  '/mach',
  '/nexus',
  '/key-services/replicant',
] as const;

export type SwipeBaseRoute = (typeof SWIPE_BASE_ROUTES)[number];

export const normalizePathname = (pathname: string) => {
  if (!pathname) return '/';
  if (pathname === '/') return '/';
  return pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
};

export const resolveSwipeKey = (pathname: string): SwipeBaseRoute | '/' => {
  const normalized = normalizePathname(pathname);
  const match = SWIPE_BASE_ROUTES.find(
    (route) => normalized === route || normalized.startsWith(`${route}/`)
  );
  return (match ?? '/') as SwipeBaseRoute | '/';
};

export const isSwipeBaseRoute = (pathname: string): pathname is SwipeBaseRoute => {
  const normalized = normalizePathname(pathname);
  return SWIPE_BASE_ROUTES.includes(normalized as SwipeBaseRoute);
};

export const isSwipeSubRoute = (pathname: string) => {
  const normalized = normalizePathname(pathname);
  return SWIPE_BASE_ROUTES.some(
    (route) => normalized !== route && normalized.startsWith(`${route}/`)
  );
};

export const isOverlayRoute = (pathname: string) => {
  const normalized = normalizePathname(pathname);

  if (isSwipeBaseRoute(normalized)) return false;
  if (isSwipeSubRoute(normalized)) return true;

  return OVERLAY_BASE_ROUTES.some(
    (route) => normalized === route || normalized.startsWith(`${route}/`)
  );
};

export const stripHashAndQuery = (href: string) => {
  if (!href) return '/';
  const hashIndex = href.indexOf('#');
  const queryIndex = href.indexOf('?');
  let endIndex = href.length;
  if (hashIndex !== -1) {
    endIndex = Math.min(endIndex, hashIndex);
  }
  if (queryIndex !== -1) {
    endIndex = Math.min(endIndex, queryIndex);
  }
  const trimmed = href.slice(0, endIndex);
  return trimmed || '/';
};
